export const Routes = [
	{
		id: 1,
		identifier: "about",
		title: "About",
	},
	{
		id: 2,
		identifier: "advisors",
		title: "Advisory Board",
	},
	{
		id: 3,
		identifier: "",
		title: "Mentors",
		dropdown: [
			{
			  id: 1,
			  title: "Cohort I",
			  identifier: "cohortI-mentors",
			  isDifferentPage: true,
			},
			{
			  id: 2,
			  title: "Cohort II",
			  identifier: "cohortII-mentors",
			  isDifferentPage: true,
			},
			{
				id: 3,
				title: "Cohort III",
				identifier: "cohortIII-mentors",
				isDifferentPage: true,
			  },
			  {
				id: 4,
				title: "Cohort IV",
				identifier: "cohortIV-mentors",
				isDifferentPage: true,
			  },
			  {
				id: 5,
				title: "Cohort V",
				identifier: "cohortV-mentors",
				isDifferentPage: true,
			  },
			   {
				id: 6,
				title: "Cohort VI",
				identifier: "cohortVI-mentors",
				isDifferentPage: true,
			  },
		  ],
	},
 
	{
		id: 4,
		identifier: "",
		title: "Mentees",
		dropdown: [
		  {
			id: 1,
			title: "Cohort I",
			identifier: "winpementees",
			isDifferentPage: true,
		  },
		  {
			id: 2,
			title: "Cohort II",
			identifier: "cohortII",
			isDifferentPage: true,
		  },
		  {
			id: 2,
			title: "Cohort III",
			identifier: "cohortIII",
			isDifferentPage: true,
		  },
		  {
			id: 2,
			title: "Cohort IV",
			identifier: "cohortIV",
			isDifferentPage: true,
		  },
		  {
			id: 2,
			title: "Cohort V",
			identifier: "cohortV",
			isDifferentPage: true,
		  },
		   {
			id: 2,
			title: "Cohort VI",
			identifier: "cohortVI",
			isDifferentPage: true,
		  },
		  {
			id: 2,
			title: "Cohort VII",
			identifier: "cohortVII",
			isDifferentPage: true,
		  },
		],
	  },
	 
	{
		id: 5,
		identifier: "events",
		title: "events",
		dropdown: [
			{
			  id: 1,
			  title: "Events",
			  identifier: "events",
			  isDifferentPage: true,
			},
			{
			  id: 2,
			  title: "Testimonials",
			  identifier: "testimonials",
			  isDifferentPage: true,
			},
			 
		  ],
	},
	{
		id: 6,
		identifier: "connect",
		title: "CONNECT WITH WINPE",
		isDifferentPage: true,
	},
]

export default Routes



// WEBPACK FOOTER //
// ./src/components/Routes.js